import { graphql } from "@/gql/__generated__";

export const workerIdQuery = graphql(`
  query WorkerIDQuery {
    viewer {
      id
    }
  }
`);

export const reviewJobOfferInfoQuery = graphql(`
  query ReviewJobOfferInfo($temporaryJobOfferId: ID!) {
    temporaryJobOffer(temporaryJobOfferId: $temporaryJobOfferId) {
      id
      officeFollowed
      mapLocationReported
      workCondition {
        formatWorkDate
        startWorkTime
        endWorkTime
      }
      postedClientOffice {
        name
        clientOfficeId
      }
    }
  }
`);

export const reportMapLocationMutation = graphql(`
  mutation ReportMapLocation($input: ReportMapLocationInput!) {
    reportMapLocation(input: $input) {
      temporaryJobOffer {
        id
        mapLocationReported
      }
    }
  }
`);
